import { Coins, Plus } from "lucide-react";
import { Link } from "react-router-dom";
import useWalletStore from "../../store/wallet.store";

// Compact balance indicator for the global navbar.
// Hides itself when balance is unloaded (auth flake) or when the API returned
// a balance but the wallet has been locked.
//
// When balance is low / zero, a "+ Top up" pill renders next to the badge
// instead of making the user click through to /account/wallet first and
// then click again to top up. Drops a click out of the revenue path.
export default function WalletBadge() {
  const balance = useWalletStore((s) => s.balance);
  if (!balance) return null;

  const credits = balance.balance_credits ?? 0;
  const locked = !!balance.is_locked;
  const showTopupCta = !locked && credits < 50;

  return (
    <div className="flex items-center gap-1">
      <Link
        to="/account/wallet"
        title={locked ? "Wallet locked — contact support" : `${credits} Zencredits — manage wallet`}
        className={`flex items-center gap-1.5 h-8 px-2.5 rounded-md text-xs transition-colors ${
          locked
            ? "bg-rose-500/15 text-rose-300 hover:bg-rose-500/25"
            : credits === 0
            ? "bg-amber-500/15 text-amber-300 hover:bg-amber-500/25"
            : "bg-emerald-500/15 text-emerald-300 hover:bg-emerald-500/25"
        }`}
      >
        <Coins className="w-3.5 h-3.5" />
        <span className="font-semibold tabular-nums">{credits}</span>
        <span className="hidden sm:inline">{credits === 1 ? "Zencredit" : "Zencredits"}</span>
      </Link>
      {showTopupCta && (
        <Link
          to="/account/topup"
          title="Buy Zencredits"
          className="flex items-center gap-1 h-8 px-2 rounded-md text-[11px] bg-amber-500 text-black hover:bg-amber-400 font-semibold transition-colors"
        >
          <Plus className="w-3 h-3" />
          <span className="hidden sm:inline">Top up</span>
        </Link>
      )}
    </div>
  );
}
